module.exports = "/static/Images/Roboto/Roboto-Regular.ttf";